export enum TaskFilter {
  Open_Tasks = 'OpenTasks',
  Due_Today = 'DueToday',
  Upcoming = 'Upcoming',
  Overdue = 'Overdue',
  To_Do = 'To-Do',
  Email = 'Email',
  Call = 'Call',
  Completed = 'Completed',
  Cancelled = 'Cancelled',
  Deferred = 'Deferred'
}
